import axios from "./axiosInstance";

const BookingFormAPI = {
  postBookingFormAPI: (params) => axios.post(`/bookNow`,params),
  paymentConfirmed: (payload) => axios.post("verify-payment", payload),
};

export default BookingFormAPI;